import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    main: {
      width: '65rem',
      margin: '0 auto',
      padding: '2rem',

      '& button[aria-label=Voltar]': {
        padding: '.8rem',
        marginLeft: '-0.8rem',
        marginRight: '0.5rem',
      },

      '& .MuiTypography-h3': {
        fontSize: '1.6rem',
        marginTop: '3rem',
        marginBottom: '1rem',
      },
    },
  }),
)
